import {Component, effect, input, output} from '@angular/core';
import {TaListBase} from '../../../pages/ta-list-base.directive';
import {Button} from 'primeng/button';
import {Chip} from 'primeng/chip';
import {DatePipe, NgClass} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {InputText} from 'primeng/inputtext';
import {TableModule} from 'primeng/table';
import {Checkbox} from 'primeng/checkbox';
import {toTAStatusText} from '../../../../util/app.types';
import {BasicTaDetails, FullTaDetails} from '../../../../api';
import {PrepaidIndicatorComponent} from '../../prepaid-indicator/prepaid-indicator.component';
import {AttachmentIndicatorComponent} from '../../attachment-indicator/attachment-indicator.component';
import {TaCostBubbleComponent} from '../../ta-cost-bubble/ta-cost-bubble.component';
import {TaCommentCount} from '../../ta-comments/ta-comment-count';
import {taPaymentComponents} from '../../../../util/general.utils';

@Component({
  selector: 'finance-paid-in-advance-list',
  imports: [
    TaCommentCount,
    Button,
    Chip,
    DatePipe,
    FormsModule,
    InputText,
    NgClass,
    TableModule,
    Checkbox,
    PrepaidIndicatorComponent,
    AttachmentIndicatorComponent,
    TaCostBubbleComponent,
  ],
  templateUrl: './finance-paid-in-advance-list.component.html',
  styleUrl: './finance-paid-in-advance-list.component.scss',
})
export class FinancePaidInAdvanceListComponent extends TaListBase {
  availableListInput = input<BasicTaDetails[]>([]);
  processPrepaymentTaClicked = output<FullTaDetails>();
  processSelectedPrepaymentsClicked = output<BasicTaDetails[]>();

  constructor() {
    super();
    effect(() => {
      this.availableTaList.set(this.availableListInput());
    });
  }

  protected readonly toTAStatusText = toTAStatusText;
  protected readonly taPaymentComponents = taPaymentComponents;
}
